/**
 * Equipment profiles database.
 */

export const EQUIPMENT_PROFILES = [
  {
    id: 'grainfather_g30',
    name: 'Grainfather G30 v2 (23L)',
    batchVolume: 23,
    efficiency: 75,
    boilOffRate: 2.8,
    kettleLoss: 2.0,
    fermenterLoss: 1.0,
    grainAbsorption: 0.96,
    mashRatio: 3.0,
  },
  {
    id: 'grainfather_g40',
    name: 'Grainfather G40 (38L)',
    batchVolume: 38,
    efficiency: 77,
    boilOffRate: 3.2,
    kettleLoss: 3.0,
    fermenterLoss: 1.5,
    grainAbsorption: 0.96,
    mashRatio: 3.0,
  },
  {
    id: 'brewtools_b40',
    name: 'Brewtools B40pro (30L)',
    batchVolume: 30,
    efficiency: 78,
    boilOffRate: 3.5,
    kettleLoss: 2.5,
    fermenterLoss: 1.5,
    grainAbsorption: 0.96,
    mashRatio: 3.0,
  },
  {
    id: 'brewtools_b80',
    name: 'Brewtools B80pro (50L)',
    batchVolume: 50,
    efficiency: 80,
    boilOffRate: 4.5,
    kettleLoss: 3.5,
    fermenterLoss: 2.0,
    grainAbsorption: 0.96,
    mashRatio: 3.0,
  },
  {
    id: 'brewzilla_35l',
    name: 'BrewZilla / Robobrew 35L Gen 4 (20L)',
    batchVolume: 20,
    efficiency: 72,
    boilOffRate: 3.0,
    kettleLoss: 2.0,
    fermenterLoss: 1.0,
    grainAbsorption: 0.96,
    mashRatio: 3.0,
  },
  {
    id: 'brewzilla_65l',
    name: 'BrewZilla 65L Gen 4 (45L)',
    batchVolume: 45,
    efficiency: 75,
    boilOffRate: 4.0,
    kettleLoss: 3.0,
    fermenterLoss: 1.5,
    grainAbsorption: 0.96,
    mashRatio: 3.0,
  },
  {
    id: 'brewmonk_30l',
    name: 'Brew Monk 30L (20L)',
    batchVolume: 20,
    efficiency: 73,
    boilOffRate: 3.0,
    kettleLoss: 2.0,
    fermenterLoss: 1.0,
    grainAbsorption: 0.96,
    mashRatio: 3.0,
  },
  {
    id: 'coobra_30l',
    name: 'Coobra Craft Brewer 30 v5 (20L)',
    batchVolume: 20,
    efficiency: 72,
    boilOffRate: 3.0,
    kettleLoss: 2.0,
    fermenterLoss: 1.0,
    grainAbsorption: 0.96,
    mashRatio: 3.0,
  },
  {
    id: 'brewster_beacon_40',
    name: 'Brewster Beacon 40L (25L)',
    batchVolume: 25,
    efficiency: 74,
    boilOffRate: 3.2,
    kettleLoss: 2.2,
    fermenterLoss: 1.2,
    grainAbsorption: 0.96,
    mashRatio: 3.0,
  },
  {
    id: 'speidel_20l',
    name: 'Speidel Braumeister 20L',
    batchVolume: 20,
    efficiency: 78,
    boilOffRate: 2.5,
    kettleLoss: 1.8,
    fermenterLoss: 1.0,
    grainAbsorption: 0.96,
    mashRatio: 3.0,
  },
  {
    id: 'klarstein_30l',
    name: 'Klarstein Mundschenk 30L (20L)',
    batchVolume: 20,
    efficiency: 72,
    boilOffRate: 3.0,
    kettleLoss: 2.0,
    fermenterLoss: 1.0,
    grainAbsorption: 0.96,
    mashRatio: 3.0,
  },
  {
    id: 'igloo_cooler_36l',
    name: 'Kylväska / Tre-kärls-system (36L Igloo + Gryta)',
    batchVolume: 20,
    efficiency: 76,
    boilOffRate: 3.0,
    kettleLoss: 1.5,
    fermenterLoss: 1.0,
    grainAbsorption: 0.96,
    mashRatio: 3.0,
  },
  {
    id: 'biab_20l',
    name: 'BIAB / Påsbryggning (30L Spisgryta)',
    batchVolume: 20,
    efficiency: 70,
    boilOffRate: 3.2,
    kettleLoss: 1.5,
    fermenterLoss: 1.0,
    grainAbsorption: 0.8,
    mashRatio: 4.5,
  },
  {
    id: 'koksbryggeriet_4l',
    name: 'Lilla Köksbryggeriet 4L (Spisbryggning)',
    batchVolume: 4,
    efficiency: 68,
    boilOffRate: 1.0,
    kettleLoss: 0.5,
    fermenterLoss: 0.3,
    grainAbsorption: 1.0,
    mashRatio: 3.5,
  },
  {
    id: 'custom_30l',
    name: 'Standard Gryta 30L',
    batchVolume: 20,
    efficiency: 75,
    boilOffRate: 3.0,
    kettleLoss: 2.0,
    fermenterLoss: 1.0,
    grainAbsorption: 0.96,
    mashRatio: 3.0,
  },
];
